module.exports = "#version 300 es\nprecision highp float;\n\nin vec2 fs_UV;\nout vec4 out_Col;\n\nuniform sampler2D u_gb3;\nuniform float u_GodRay_DS;\n\nuniform sampler2D u_frame;\n\nvoid main() {\n  vec4 gb3 = texture(u_gb3, fs_UV * u_GodRay_DS);\n  out_Col = gb3;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/post32_GodRay_Pre.glsl
// module id = 53
// module chunks = 0